<!--
 * @Description: 营业所信息
 * @FilePath: /netHallOfficialAccounts/src/views/PublicNews/BusinessOffice.vue
-->
<template>
  <div class="business-office">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <template v-for="item in outletsList">
          <div class="outlets-box" v-bind:key="item.id">
            <div class="outlets-news">
              <div class="outlets-news-title">
                <div> 营业厅 </div>
                <div>{{ item.outletsName }}</div>
              </div>
              
              <div v-if="item.businessScope" class="news-row">
                <img :src="icPhone" alt="" />
                <span @click="showCallPhone(item.businessScope)">{{ item.businessScope }}</span>
              </div>
              <div v-if="item.address" class="news-row">
                <img :src="icLocaltion" alt="" />
                <span @click="copy(item.address)" class="tag-read">{{ item.address }}</span>
              </div>
            <div v-if="item.address" class="news-row">
                <img :src="icLocaltion" alt="" />
                <span @click="toNetHallMap(item)" class="tag-read">查看地图</span>
              </div>
            </div>
            <van-divider v-if="item.abodeRemark" class="box-divider" />
            <div v-if="item.abodeRemark" class="outlets-remarks">{{ item.abodeRemark }}</div>
          </div>
        </template>
      </van-list>
    </van-pull-refresh>
    <!-- 拨打电话 -->
    <tel-popup :showCallFlag="showCall" @clickCancelTel="cancelTel" ref="telPopupModal" />
  </div>
</template>

<script>
import icPhone from '@/assets/icon/ic_phone.png';
import icLocaltion from '@/assets/icon/ic_localtion.png';
import { selectListPageForNetHall } from '@/api/business';
import TelPopup from '@/views/Home/module/telPopup';
import Clipboard from 'clipboard';
import { Toast } from 'vant';
export default {
  name: 'BusinessOffice',
  components: {
    TelPopup,
  },
  data() {
    return {
      icPhone,
      icLocaltion,
      outletsList: [],
      loading: false,
      finished: false,
      refreshing: false,
      options: {
        condition: {
          abodeAddress: '',
          abodeName: '',
        },
        current: 1,
        size: 10,
      },
      showCall: false,
    };
  },
  methods: {
    toNetHallMap(item) {
      // let newNetData = this.netData.map(val => {
      //   val.isActive = val.outletsName === item.outletsName;
      //   val.lng = val.longitude;
      //   val.lat = val.latitude;
      //   return val;
      // });
      let newNetData = item;
      this.$router.push({
        path: "/NetHallMap",
        query: {
          listData: encodeURIComponent(JSON.stringify(newNetData)),
          avtiveNet: item.outletsName
        }
      });
    },
    onLoad() {
      this.loading = true;
      this.selectListPageForNetHall();
    },
    onRefresh() {
      this.loading = true;
      this.options.current = 1;
      this.outletsList = [];
      this.selectListPageForNetHall();
    },
    async selectListPageForNetHall() {
      // let list = [{"outletsId":"1871725169080864769","outletsName":"石岛营业厅","address":"威海市荣成市G228富兴房地产馨海康苑南侧约190米石岛新天地广场","phoneNumber":"","businessTime":"","businessScope":"联系电话：0631-7385878","longitude":"122.421235","latitude":"36.878579","sort":1,"createBy":"rcAdmin","createTime":"2024-12-25 09:10:29","updateBy":"丛晗","updateTime":"2025-04-02 18:30:26","tenantId":"1866028748747345922","delFlag":false,"abodeCode":"1866154424406142977","abodeName":"荣成水务集团"}]
      const { status, resultData } = await selectListPageForNetHall();
      if (status === 'complete') {
        this.outletsList = [...resultData];
        this.finished = true;
        this.loading = false;
      } else {
        this.finished = true;
        this.loading = false;
      }
      if (this.refreshing) {
        this.refreshing = false;
      }
    },
    // 拨打电话
    showCallPhone(tel) {
      this.$refs.telPopupModal.telPhone = tel;
      this.showCall = true;
    },
    cancelTel(value) {
      this.showCall = false;
    },
    copy(address) {
      var clipboard = new Clipboard('.tag-read', {
        text: function() {
          return address;
        },
      });
      clipboard.on('success', (e) => {
        Toast({ message: '复制成功！' });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        // 不支持复制
        console.log('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.business-office {
  .outlets-box {
    background: #ffffff;
    border-radius: 8px;
    margin: 16px;
    padding: 16px;

    .outlets-news {
      .outlets-news-title {
        display: flex;
        align-items: flex-start;
        > div:first-child {
          width: 40px;
          padding: 2px 0;
          margin-right: 10px;
          background: #ecf1fe;
          border-radius: 4px;
          font-size: 12px;
          color: #637fb7;
          text-align: center;
        }
        > div:last-child {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
        }
      }

      .news-row {
        display: flex;
        align-items: flex-start;
        padding-top: 8px;
        > img {
          height: 20px;
        }

        > span {
          margin-left: 10px;
          font-size: 14px;
          color: #4c5562;
        }
      }

      > div {
        display: flex;
        align-items: center;
      }
    }
  }

  .box-divider {
    margin: 0;
    padding-top: 8px;
  }

  .outlets-remarks {
    padding-top: 8px;
    font-size: 12px;
    color: #8a96a4;
  }
}
</style>
